export default {
	SET_PAGE(state, payload) {
		state.listing.page = payload
	},

	SET_CASE_ID(state, payload) {
		state.caseId = payload
	},

	SET_OFFER_ID(state, payload) {
		state.offerId = payload
	},

	SET_PROPOSAL_ID(state, payload) {
		state.proposalId = payload
	},

	SET_CASE(state, payload) {
		state.case = payload
	},

	ADD_CASE_FACT(state, payload) {
		state?.case?.facts?.push(payload)
	},

	UPDATE_CASE_FACT(state, payload) {
		console.log("Update fact", payload)
		const { id, type, value } = payload
		state.case.facts = state?.case?.facts?.map(fact => {
			// update fact
			if (fact.id === id) return payload

			// just return not updated fact
			return { ...fact }
		})
	},

	SET_PROPOSALS(state, payload) {
		state.proposals = payload
	},

	SET_GOD_MODE(state, payload) {
		state.isGodMode = payload
	},

	ADD_SUBSCRIBER(state, { eventName, callback }) {
		const currentSubscribers = [
			...(state?.subscribers?.[eventName] || []),
			callback
		]
		state.subscribers = {
			...state.subscribers,
			[eventName]: currentSubscribers
		}
	},

	// Function that updates a piece of the state
	// value is the new value
	// fieldName is the name of the field to update
	// actionType is the type of action to do on the piece of the case (update a field, push in an array...)
	// stateFilter is a function that returns only the part of the state we want to update
	// e.g : we want to update state.case.holder.firstName : value = "Bob", fieldName = "firstName", actionType = "update", stateFilter = function that takes state and returns state.case.holder
	// e.g : we want to push in state.case.proposals.basket.benefitOptions : value = newOption, fieldName = "benefitOptions", actionType = "push", stateFilter = function that returns the offer
	UPDATE_CASE(state, { value, fieldName, stateFilter, actionType }) {
		if (actionType === "update") stateFilter(state)[fieldName] = value
		if (actionType === "push") {
			if (stateFilter(state)[fieldName] instanceof Array)
				stateFilter(state)[fieldName].push(value)
			else stateFilter(state)[fieldName] = [value]
		}
		if (actionType === "remove" && stateFilter(state) instanceof Array) {
			const item = stateFilter(state).find(item => item[fieldName] === value)
			const index = stateFilter(state).indexOf(item)
			stateFilter(state).splice(index, 1)
		}
	},

	publish(state, { eventName, data }) {
		console.log(
			"publisihing",
			eventName,
			state.subscribers /* [eventName] */,
			state.subscribers[eventName],
			Array.isArray(state.subscribers[eventName])
		)
		if (
			!state.subscribers[eventName] ||
			!Array.isArray(state.subscribers[eventName])
		) {
			return
		}
		state.subscribers[eventName].forEach(callback => {
			callback(data)
		})
	}
}
